export default "__VITE_ASSET__CepnhcZz__"